// The resting order of a list whose service order is by none of its columns.
//
// desk-ui's useListSort takes a resting order so that, before anybody presses
// a head, aria-sort can report the order the list arrived in. That is right for
// Clients (A to Z by name) and Activity (newest first). It is wrong for a list
// the service orders by something no column shows: the activation directory
// (last event, with the ones nothing has arrived for first) and the Ride desk
// (the game's own order). Naming a column as the resting order there would tell
// a screen reader the list is sorted by something it is not.
//
// So those lists rest on a key no head carries. Every head then reports
// aria-sort "none", which is the truth, and the key is never sent: a list
// nobody has sorted asks for no order at all.

import type { ListSort } from "@nova/desk-ui/page";

/** The resting key of a list in the service's own order, which is by no column. */
export type AsSent = "as-sent";
export const AS_SENT: AsSent = "as-sent";

/** The column the reader asked for, or null where they have asked for nothing. */
export function asked<K extends string>(order: { readonly sort: ListSort<K | AsSent>; readonly lit: boolean }): {
  readonly key: K;
  readonly dir: "asc" | "desc";
} | null {
  const { key, dir } = order.sort;
  return order.lit && key !== AS_SENT ? { key: key as K, dir } : null;
}
